import { render, staticRenderFns } from "./SmsPhoneTypeSelector.vue?vue&type=template&id=1ef312de"
import script from "./SmsPhoneTypeSelector.vue?vue&type=script&lang=js"
export * from "./SmsPhoneTypeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports